<template>
  <svg viewBox="0 0 48 48" fill="currentColor">
    <path
      d="M42 28C41 25 40 23 38 20 38 9 32 2 24 2 16 2 10 9 10 20 8 23 7 25 6 28 4 34 5 38 6 38 7 38 10 33 10 32 10 35 11 40 15 42 14 42 10 43 10 44 10 46 23 45 24 44 25 45 38 46 38 44 38 43 34 42 33 42 37 40 38 35 38 32 38 33 41 38 42 38 43 38 44 34 42 28Z"
    />
  </svg>
</template>
